import { Expose } from "class-transformer";
import { IsBoolean, IsString } from "class-validator";

export class UserInRole {
  @Expose()
  @IsString()
  userName!: string;
  @Expose()
  @IsBoolean()
  isInRole!: boolean;
  @Expose()
  @IsString()
  id!: string;
}
